module.exports = __webpack_public_path__ + "static/img/zxx.8aac74f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zxx.png
// module id = D/vy
// module chunks = 35